import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
//@ts-nocheck
import React, { useState } from 'react';
import { Button as AntdButton, Flex, Form, Upload, Input, message } from 'antd';
import Icon from '../../../../../components/common/Icon';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../../../editor.style';
import { useSelector, useDispatch } from 'react-redux';
import { _downloadExcelForLanguage, _uploadExcelForLanguage, } from '../../../../../shared/httpservice/apis/multiLanguages';
import { getSiteLanguagesAction } from '../../../../..//store/mutliLanguageSlice';
const LanguageDetailPanel = ({ isOpen, onBack, data, socket }) => {
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [uploadFileList, setUploadFileList] = useState([]);
    const siteId = useSelector((state) => state?.site?.checkSite?.response?.data?.siteId);
    // Helper function to convert a file to a Base64 string.
    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };
    const downloadExcelFile = async () => {
        if (siteId && data) {
            try {
                const response = await _downloadExcelForLanguage(siteId, data?.multilingualId);
                // Create a blob from the response data.
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'] || 'application/octet-stream',
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${data?.languageName || 'language'}.xlsx`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
            }
            catch (error) {
                console.error('Error downloading Excel file:', error);
                message.error('Error downloading file, please regenerate and try again');
            }
        }
    };
    // Upload props with Base64 conversion, removal of the prefix, and file list control.
    const uploadProps = {
        accept: '.xls,.xlsx',
        maxCount: 1,
        fileList: uploadFileList,
        beforeUpload: (file) => {
            const fileExtension = file.name.split('.').pop()?.toLowerCase();
            if (fileExtension !== 'xlsx' && fileExtension !== 'xls') {
                message.error('You can only upload Excel files.');
                return Upload.LIST_IGNORE;
            }
            return false; // Prevent auto-upload.
        },
        onChange: async (info) => {
            // Update the state with the new file list.
            setUploadFileList(info.fileList);
            const latestFile = info.fileList[info.fileList.length - 1]?.originFileObj;
            if (latestFile) {
                try {
                    let base64 = await getBase64(latestFile);
                    if (typeof base64 === 'string') {
                        // Remove the data URL prefix.
                        base64 = base64.replace(/^data:.*;base64,/, '');
                    }
                    // Store the Base64 string in the hidden form field.
                    form.setFieldsValue({ uploadFileBase64: base64 });
                }
                catch (error) {
                    console.error('Error converting file to Base64:', error);
                    message.error('File conversion failed');
                }
            }
        },
        onRemove: () => {
            setUploadFileList([]);
        },
    };
    const onFinish = async (values) => {
        setLoading(true);
        try {
            const base64Image = values.uploadFileBase64;
            if (!base64Image) {
                message.error('Please upload an Excel file first.');
                setLoading(false);
                return;
            }
            // Upload the Excel file.
            const uploadResponse = await _uploadExcelForLanguage(siteId, data?.multilingualId, { image: base64Image });
            // Subscribe to the socket channel for this multilingual file.
            const channel = `/topic/multilingual/${data?.multilingualId}`;
            socket.emit('SUBSCRIBE', channel, { siteId, multilingualId: data?.multilingualId });
            // Prepare the message to process the Excel file.
            const messageData = { siteId, multilingualId: data?.multilingualId };
            socket.emit('PROCESS_MULTILINGUAL_EXCEL_FILE', messageData);
            // Listen for the process response.
            socket.on('PROCESS_MULTILINGUAL_EXCEL_FILE', (resp) => {
                if (resp?.data?.status === 'COMPLETED') {
                    dispatch(getSiteLanguagesAction(siteId));
                    message.success('Processing excel file completed');
                }
            });
            form.resetFields(); // Reset form values.
            setUploadFileList([]); // Clear the upload file list.
            onBack();
        }
        catch (error) {
            console.error('Error processing Excel file:', error);
            if (error?.response?.data?.message === "User has not downloaded the Excel file. Please download the Excel file first and try to upload.") {
                message.error("Please download the generated excel file and try to upload again");
            }
            else {
                message.error('Error processing Excel file');
            }
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx(LeftPanel, { isOpen: isOpen, style: { width: '340px' }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: onBack }), _jsxs("h3", { children: ["Language: ", data?.languageName || 'English'] })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, children: _jsx(Form, { form: form, layout: "vertical", onFinish: onFinish, children: _jsxs(_Fragment, { children: [_jsx(Flex, { align: "center", justify: "space-between", style: { marginBottom: 16 }, children: _jsx(AntdButton, { icon: _jsx(Icon, { icon: "download" }), variant: "text", onClick: downloadExcelFile, children: "Download Excel" }) }), _jsx(Form.Item, { label: "Upload Excel", children: _jsxs(Upload.Dragger, { ...uploadProps, children: [_jsx("p", { className: "ant-upload-drag-icon", children: _jsx(Icon, { icon: "upload", size: 24 }) }), _jsx("p", { className: "ant-upload-text", children: "Click or drag Excel file here to upload" })] }) }), _jsx(Form.Item, { name: "uploadFileBase64", hidden: true, children: _jsx(Input, {}) })] }) }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(AntdButton, { onClick: () => {
                                    onBack();
                                    form.resetFields();
                                    setUploadFileList([]);
                                }, color: "danger", variant: "filled", children: "Cancel" }), _jsx(AntdButton, { loading: loading, onClick: () => form.submit(), color: "primary", variant: "solid", children: "Process" })] })] }) }) }));
};
export default React.memo(LanguageDetailPanel);
